import DateFnsUtils from "@date-io/date-fns";
import { FormHelperText } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import { DatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Prompt } from "react-router";
import { bindActionCreators } from "redux";
import { harvestYearDetail } from "../../../config/harvestYearDetail";
import {
  commodityList,
  getCommodityVariertyList
} from "../../../modules/contract/action";
import {
  deleteReconciledTicketDetails,
  emptyStateOnReconciliation,
  getReconciledTicketDetails,
  getTicketDetails,
  postTicketDetails,
  upDateTicketDetails
} from "../../../modules/reconciliation/action";
import Button from "../../FormElement/Button";
import ConfirmationDialog from "../../FormElement/ConfirmationDialog";
import Dropdown from "../../FormElement/Dropdown";
import { validForm } from "../../FormElement/FormValidator";
import InputFiled from "../../FormElement/InputFiled";

class RecievedDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketDetailsRecieved: {
        fieldReceivedGrossLoadWeight: "",
        fieldReceivedTareLoadWeight: "",
        fieldReceivedNetLoadWeight: "",
        fieldsReceivedMoisture: "",
        receivedcommodity: "",
        receivedcommodityVariety: props.ReconciledData
          ? props.ReconciledData.receivedcommodityVariety
          : "",
        receivedGrossBushels: "",
        receivedDeductionBushels: "",
        receivedNetBushels: "",
        receivedDate: props.ReconciledData
          ? props.ReconciledData.receivedDate
          : new Date().toISOString(),
        fieldAcceptedLoadWeight: "",
        fieldRejectedLoadWeight: "",
        payloadTicketNumber: "",
        billOfLading: "",
        foreignMatter: "",
        shrinkReconciliation: props.ReconciledData
          ? props.ReconciledData.shrinkReconciliation
          : "1",
        recievedPayloadNetDestinationShrunkBushels: "",
        recievedTestWeight: "",
        status: ""
      },
      ticketNumber: "",
      commodityList: [],
      buttonLabel: "Reconcile",
      formErrors: {
        payloadTicketNumber: "",
        receivedNetBushels: "",
        receivedcommodity: "",
        fieldReceivedTareLoadWeight: "",
        receivedcommodityVariety:""
      },
      showMessage: false,
      isButtonDisabled: false,
      commodityVarietyListOption: [],
      showModal: false,
      open: true,
      edited: false,
      commodityVarietyLbsPerBushel: 0,
      isMandatory: false,
      reDirect: false,
      mandatoryFields: [
        "receivedcommodity",
        "payloadTicketNumber",
        "recievedPayloadNetDestinationShrunkBushels",
        "fieldReceivedGrossLoadWeight",
        "fieldReceivedTareLoadWeight"
      ],
      showCancelModal: false,
      harvestYear: harvestYearDetail().name
    };
  }

  checkAllMandatoryFieldsAreFilled = () => {
    const { ticketDetailsRecieved, mandatoryFields } = this.state;
    let mFields = [];
    let nonMandatory = [
      "fieldReceivedGrossLoadWeight",
      "fieldReceivedTareLoadWeight"
    ];
    let shrunkField = "recievedPayloadNetDestinationShrunkBushels";
    if (
      ticketDetailsRecieved.fieldReceivedGrossLoadWeight === "" ||
      ticketDetailsRecieved.fieldReceivedGrossLoadWeight === null ||
      ticketDetailsRecieved.fieldReceivedGrossLoadWeight === undefined
    ) {
      mFields = mandatoryFields.filter(function(item) {
        return !nonMandatory.includes(item);
      });
    } else {
      mFields = mandatoryFields.filter(item => item !== shrunkField);
    }
    let blankCells = 0;
    blankCells = mFields.map(
      cell =>
        ticketDetailsRecieved[cell] === "" ||
        ticketDetailsRecieved[cell] === undefined ||
        ticketDetailsRecieved[cell] === null
    );
    return blankCells.includes(true);
  };

  checkTicket = () => {
    const { ticketNumber } = this.state;
    if (ticketNumber === "" || ticketNumber === undefined) {
      return true;
    } else return false;
  };

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }
  componentDidMount() {
    // const { commodityListAction } = this.props;
    // commodityListAction();
    const harvestYearId = harvestYearDetail().name;
    this.props.actions.commodityList();
    this.props.actions.getCommodityVariertyList(harvestYearId);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ open: true });
    if (
      nextProps.ticketListId &&
      nextProps.ticketListId !== this.props.ticketListId
    ) {
      this.setState({
        ticketNumber: nextProps.ticketListId && nextProps.ticketListId
      });
    }

    if (nextProps.clearError) {
      this.setState({
        formErrors: {
          payloadTicketNumber: "",
          receivedNetBushels: "",
          receivedcommodity: "",
          receivedcommodityVariety: ""
        },
        ticketDetailsRecieved: {
          fieldReceivedGrossLoadWeight: "",
          fieldReceivedTareLoadWeight: "",
          fieldReceivedNetLoadWeight: "",
          fieldsReceivedMoisture: "",
          receivedcommodity: nextProps.ReconciledData
            ? nextProps.ReconciledData.receivedcommodity
              ? nextProps.ReconciledData.receivedcommodity.id
              : ""
            : "",
          receivedcommodityVariety: nextProps.ReconciledData
            ? nextProps.ReconciledData.receivedcommodityVariety
              ? nextProps.ReconciledData.receivedcommodityVariety.id
              : ""
            : "",
          receivedGrossBushels: "",
          receivedDeductionBushels: "",
          receivedNetBushels: "",
          receivedDate: new Date().toISOString(),
          fieldAcceptedLoadWeight: "",
          fieldRejectedLoadWeight: "",
          payloadTicketNumber: "",
          billOfLading: "",
          foreignMatter: "",
          shrinkReconciliation: "1"
        },
        showModal: false
        // ticketNumber: ""
      });
    }

    if (
      nextProps.ReconciledData &&
      nextProps.ReconciledData !== this.props.ReconciledData
    ) {
      this.setState(
        {
          ticketDetailsRecieved: {
            fieldReceivedGrossLoadWeight: nextProps.ReconciledData
              ? nextProps.ReconciledData.fieldReceivedGrossLoadWeight
              : "",
            fieldReceivedTareLoadWeight: nextProps.ReconciledData
              ? nextProps.ReconciledData.fieldReceivedTareLoadWeight
              : "",
            fieldReceivedNetLoadWeight: nextProps.ReconciledData
              ? nextProps.ReconciledData.fieldReceivedNetLoadWeight
              : "",
            fieldsReceivedMoisture: nextProps.ReconciledData
              ? nextProps.ReconciledData.fieldsReceivedMoisture
              : "",
            receivedcommodity: nextProps.ReconciledData
              ? nextProps.ReconciledData.receivedcommodity
                ? nextProps.ReconciledData.receivedcommodity.id
                : ""
              : "",
            receivedcommodityVariety: nextProps.ReconciledData
              ? nextProps.ReconciledData.receivedcommodityVariety
                ? nextProps.ReconciledData.receivedcommodityVariety.id
                : ""
              : "",
            receivedGrossBushels: nextProps.ReconciledData
              ? nextProps.ReconciledData.receivedGrossBushels
              : "",
            receivedDeductionBushels: nextProps.ReconciledData
              ? nextProps.ReconciledData.receivedDeductionBushels
              : "",
            receivedNetBushels: nextProps.ReconciledData
              ? nextProps.ReconciledData.receivedNetBushels
              : "",
            receivedDate: nextProps.ReconciledData
              ? nextProps.ReconciledData.receivedDate
                ? nextProps.ReconciledData.receivedDate
                : new Date().toISOString()
              : "",
            fieldAcceptedLoadWeight: nextProps.ReconciledData
              ? nextProps.ReconciledData.fieldAcceptedLoadWeight
              : "",
            fieldRejectedLoadWeight: nextProps.ReconciledData
              ? nextProps.ReconciledData.fieldRejectedLoadWeight
              : "",
            payloadTicketNumber: nextProps.ReconciledData
              ? nextProps.ReconciledData.payloadTicketNumber
              : "",
            billOfLading: nextProps.ReconciledData
              ? nextProps.ReconciledData.billOfLading
              : "",
            foreignMatter: nextProps.ReconciledData
              ? nextProps.ReconciledData.foreignMatter
              : "",
            shrinkReconciliation: nextProps.ReconciledData
              ? nextProps.ReconciledData.shrinkReconciliation
              : "1",
            recievedPayloadNetDestinationShrunkBushels: nextProps.ReconciledData
              ? nextProps.ReconciledData
                  .recievedPayloadNetDestinationShrunkBushels
              : "",
            recievedTestWeight: nextProps.ReconciledData
              ? nextProps.ReconciledData.recievedTestWeight
              : ""
          }
        },
        () => {
          this.getVariertyList(
            this.state.ticketDetailsRecieved.receivedcommodity
          );
        }
      );
    }

    // if (
    //     nextProps.commodityList &&
    //     nextProps.commodityList !== this.props.commodityList
    //     )
    //     this.setState({
    //         commodityList: nextProps.commodityList
    //     });

    if (Object.keys(nextProps.ReconciledData).length === 0) {
      this.setState({
        ticketDetailsRecieved: {
          fieldReceivedGrossLoadWeight: "",
          fieldReceivedTareLoadWeight: "",
          fieldReceivedNetLoadWeight: "",
          fieldsReceivedMoisture: "",
          receivedcommodity: "",
          receivedcommodityVariety: "",
          receivedGrossBushels: "",
          receivedDeductionBushels: "",
          receivedNetBushels: "",
          receivedDate: new Date().toISOString(),
          fieldAcceptedLoadWeight: "",
          fieldRejectedLoadWeight: "",  
          payloadTicketNumber: "",
          billOfLading: "",
          foreignMatter: "",
          shrinkReconciliation: "1",
          recievedPayloadNetDestinationShrunkBushels: "",
          recievedTestWeight: ""
        }
      });
    }
  }

  getVariertyList = (id, VarietyId) => {
    console.log(this.props,"propss");
    const { commodityVarietyList } = this.props;
    let option =
      commodityVarietyList &&
      commodityVarietyList.filter(
        value => value.commodityResponseDTO.id === id
      );
    this.setState(
      prevState => {
        return {
          ...prevState,
          commodityVarietyListOption: option,
          ticketDetailsRecieved: {
            ...prevState.ticketDetailsRecieved,
            receivedcommodityVariety: VarietyId ? VarietyId
              : this.props.ReconciledData?this.props.ReconciledData.receivedcommodityVariety?
                  this.props.ReconciledData.receivedcommodityVariety.id:option[0]? option[0].id
              : "":option[0]
              ? option[0].id
              : ""
          }
        };
      },
      () => {
        this.getGrossShrunkPayloadBushelsCalc();
      }
    );
  };

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    this.setState({ isButtonDisabled: false });
    let { name, type, value } = event.target;
    if (type === "number") {
      value = Number(value);
    }

    if (name === "receivedcommodity") {
      this.setState(prevState => {
        return {
          ticketDetailsRecieved: {
            ...prevState.ticketDetailsRecieved,
            [name]: value
          }
        };
      });
      this.getVariertyList(value);
    }

    if (name === "billOfLading" || name === "payloadTicketNumber") {
      if (value.match(/^(.|\n){0,21}$/)) {
        this.setState(prevState => {
          return {
            ticketDetailsRecieved: {
              ...prevState.ticketDetailsRecieved,
              [name]: value
            }
          };
        });
      }
    }
    // if (name === "shrinkReconciliation") {
    //   console.log(value.match(/^([1](?:\.[0])?|0?\.[1-9])$/));
    //   if (value.match(/^([1](?:\.[0])?|0?\.[1-9])$/)) {
    //     this.setState(prevState => {
    //       return {
    //         ticketDetailsRecieved: {
    //           ...prevState.ticketDetailsRecieved,
    //           [name]: value
    //         }
    //       };
    //     });
    //   }
    // }
    else if (
      // name === "payloadTicketNumber" ||
      name === "fieldReceivedGrossLoadWeight" ||
      name === "fieldReceivedTareLoadWeight" ||
      name === "fieldReceivedNetLoadWeight" ||
      name === "fieldsReceivedMoisture" ||
      name === "receivedGrossBushels" ||
      name === "receivedDeductionBushels" ||
      name === "receivedNetBushels" ||
      name == "fieldAcceptedLoadWeight" ||
      name === "fieldRejectedLoadWeight" ||
      // name === "billOfLading" ||
      name === "foreignMatter" ||
      name === "shrinkReconciliation" ||
      name === "recievedPayloadNetDestinationShrunkBushels" ||
      name === "recievedTestWeight"
    ) {
      const regex =
        name === "shrinkReconciliation"
          ? /^\d{0,10}(\.\d{0,4})?$/
          : /^\d{0,10}(\.\d{0,2})?$/;
      if (value.match(regex)) {
        this.setState(
          prevState => {
            return {
              ticketDetailsRecieved: {
                ...prevState.ticketDetailsRecieved,
                [name]: value
              }
            };
          },
          () => {
            // if( name === "shrinkReconciliation") {
            //   if (value <= 0 || value > 1) {
            //     this.setState(prevState => {
            //       return {
            //         formErrors: {
            //           ...prevState.formErrors,
            //           shrinkReconciliation: "Value should be between 0 and 1"
            //         }
            //       };
            //     });
            //   }
            //     else if (value > 0 || value <= 1) {
            //       this.setState(
            //         prevState => {
            //           return {
            //             ticketDetailsRecieved: {
            //               ...prevState.ticketDetailsRecieved,
            //               [name]: value
            //             }
            //           };
            //         })
            //     }

            // }

            if (name === "fieldReceivedGrossLoadWeight") {
              if (value === "") {
                this.setState(prevState => {
                  return {
                    formErrors: {
                      ...prevState.formErrors,
                      fieldReceivedTareLoadWeight: ""
                    }
                  };
                });
                this.setState(prevState => {
                  return {
                    ticketDetailsRecieved: {
                      ...prevState.ticketDetailsRecieved,
                      fieldReceivedTareLoadWeight: "",
                      fieldReceivedNetLoadWeight: "",
                      receivedGrossBushels: "",
                      receivedNetBushels: "",
                      foreignMatter: "",
                      receivedDeductionBushels: "",
                      recievedPayloadNetDestinationShrunkBushels: ""
                    }
                  };
                });
              }
            }

            if (
              name === "fieldReceivedGrossLoadWeight" ||
              name === "fieldReceivedTareLoadWeight"
            ) {
              this.setState(prevState => {
                return {
                  formErrors: {
                    ...prevState.formErrors,
                    recievedPayloadNetDestinationShrunkBushels: ""
                  }
                };
              });
              this.getNetWeightCalculation();
            }

            if (name === "shrinkReconciliation") {
              this.getGrossShrunkPayloadBushelsCalc();
            }
            if (
              name === "foreignMatter" ||
              name === "receivedDeductionBushels"
            ) {
              this.getNetPayloadShrunkBushelsCalc();
            }
          }
        );
      }
    } else {
      this.setState(prevState => {
        return {
          ticketDetailsRecieved: {
            ...prevState.ticketDetailsRecieved,
            [name]: value
          }
        };
      });
    }
  };

  getNetWeightCalculation = () => {
    const {
      fieldReceivedGrossLoadWeight,
      fieldReceivedTareLoadWeight
    } = this.state.ticketDetailsRecieved;
    if (fieldReceivedGrossLoadWeight && fieldReceivedTareLoadWeight) {
      let netWeight =
        fieldReceivedGrossLoadWeight - fieldReceivedTareLoadWeight;
      this.setState(
        prevState => {
          return {
            ticketDetailsRecieved: {
              ...prevState.ticketDetailsRecieved,
              fieldReceivedNetLoadWeight: netWeight
            }
          };
        },
        () => {
          this.getGrossShrunkPayloadBushelsCalc();
        }
      );
    } else {
      this.setState(
        prevState => {
          return {
            ticketDetailsRecieved: {
              ...prevState.ticketDetailsRecieved,
              fieldReceivedNetLoadWeight: 0
            }
          };
        },
        () => {
          this.getGrossShrunkPayloadBushelsCalc();
        }
      );
    }
  };

  getGrossShrunkPayloadBushelsCalc = () => {
    this.getcommidityLoadBushlesValue();
    const {
      fieldReceivedNetLoadWeight,
      receivedcommodity,
      shrinkReconciliation
    } = this.state.ticketDetailsRecieved;
    const { commodityVarietyLbsPerBushel } = this.state;

    if (
      fieldReceivedNetLoadWeight &&
      commodityVarietyLbsPerBushel &&
      shrinkReconciliation
    ) {
      let grossShrunkPayloadBushels = parseFloat(
        (fieldReceivedNetLoadWeight / commodityVarietyLbsPerBushel) *
          shrinkReconciliation
      ).toFixed(2);
      this.setState(
        prevState => {
          return {
            ticketDetailsRecieved: {
              ...prevState.ticketDetailsRecieved,
              receivedGrossBushels: grossShrunkPayloadBushels
            }
          };
        },
        () => {
          this.getNetPayloadShrunkBushelsCalc();
        }
      );
    } else {
      this.setState(
        prevState => {
          return {
            ticketDetailsRecieved: {
              ...prevState.ticketDetailsRecieved,
              receivedGrossBushels: 0
            }
          };
        },
        () => {
          this.getNetPayloadShrunkBushelsCalc();
        }
      );
    }
  };

  getNetPayloadShrunkBushelsCalc = () => {
    const {
      receivedGrossBushels,
      foreignMatter = 0,
      receivedDeductionBushels = 0
    } = this.state.ticketDetailsRecieved;

    // if (receivedGrossBushels && foreignMatter && receivedDeductionBushels) {
    let netPayloadShrunkBushels = parseFloat(
      receivedGrossBushels - receivedDeductionBushels - foreignMatter
    ).toFixed(2);
    this.setState(prevState => {
      return {
        ticketDetailsRecieved: {
          ...prevState.ticketDetailsRecieved,
          receivedNetBushels: netPayloadShrunkBushels
        }
      };
    });
    // }
    // else {
    //   this.setState(prevState => {
    //     return {
    //       ticketDetailsRecieved: {
    //         ...prevState.ticketDetailsRecieved,
    //         receivedNetBushels: 0
    //       }
    //     };
    //   });
    // }
  };

  getcommidityLoadBushlesValue = () => {
    const { ticketDetailsRecieved } = this.state;
    const { commodityList } = this.props;
    let selectedCommodityArray = [];
    if (ticketDetailsRecieved.receivedcommodity !== "") {
      selectedCommodityArray =
        commodityList &&
        commodityList.filter(value => {
          if (value && value.id === ticketDetailsRecieved.receivedcommodity) {
            return value;
          }
        });
    }
    this.setState({
      commodityVarietyLbsPerBushel: Number(
        selectedCommodityArray[0] && selectedCommodityArray[0].lbsPerBushel
      )
    });
  };

  handleDateChange = date => {
    if (date) {
      this.setState(
        prevState => {
          return {
            ticketDetailsRecieved: {
              ...prevState.ticketDetailsRecieved,
              receivedDate: new Date(date).toISOString()
              //moment(date._d).format("MM/DD/YYYY")
            }
          };
        },
        () => {}
      );
    }
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleReconcile = () => {
    const { ticketDetailsRecieved, ticketNumber, open } = this.state;
    const { reconciled } = this.props;
    this.setState({
      isButtonDisabled: true,
      edited: false
    });
    if (reconciled !== "Reconciled") {
      ticketDetailsRecieved.recievedPayloadNetDestinationShrunkBushels = ticketDetailsRecieved.recievedPayloadNetDestinationShrunkBushels
        ? ticketDetailsRecieved.recievedPayloadNetDestinationShrunkBushels
        : null;
      this.props.actions
        .postTicketDetails(ticketNumber, ticketDetailsRecieved)
        .then(data => {
          if (data) {
            this.setState({
              showModal: true,
              reDirect: true
            });
          }
        });
    } else {
      ticketDetailsRecieved.recievedPayloadNetDestinationShrunkBushels = ticketDetailsRecieved.recievedPayloadNetDestinationShrunkBushels
        ? ticketDetailsRecieved.recievedPayloadNetDestinationShrunkBushels
        : null;

      this.props.actions
        .upDateTicketDetails(ticketNumber, ticketDetailsRecieved)
        .then(data => {
          if (data) {
            this.setState({
              showModal: true,
              reDirect: true
            });
          }
        });
    }
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        this.setState({
          isValid: validForm(this.state.formErrors)
        });
      }
    );
  };
  handleCommodityChange = e => {
    this.handleChange(e);
    this.setState(
      {
        showMessage: true
      },
      () => {
        setTimeout(
          function() {
            this.setState({ showMessage: false });
          }.bind(this),
          3000
        );
      }
    );
  };

  handleClose = () => {
    this.setState({ open: false, showModal: false, ticketNumber: "" });
    this.props.actions.emptyStateOnReconciliation();
  };

  getfilterCommodityList = () => {
    const { commodityVarietyList } = this.props;
    let comm = commodityVarietyList !== undefined ? commodityVarietyList : {};

    let commarray = [];
    commarray = Object.keys(comm).map(value => {
      return {
        id: comm[value].commodityResponseDTO.id,
        name: comm[value].commodityResponseDTO.name
      };
    });
    const filteredArr = commarray.reduce((acc, current) => {
      const x = acc.find(item => item.id === current.id);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredArr;
  };

  toggleMandatoryFields = () => {
    const { fieldReceivedGrossLoadWeight } = this.state.ticketDetailsRecieved;

    return fieldReceivedGrossLoadWeight && fieldReceivedGrossLoadWeight !== "";
  };

  toggleMandatorywrtTare = () => {
    const { fieldReceivedTareLoadWeight } = this.state.ticketDetailsRecieved;
    return fieldReceivedTareLoadWeight !== "";
  };

  checkTareWeight = () => {
    const {
      fieldReceivedGrossLoadWeight,
      fieldReceivedTareLoadWeight
    } = this.state.ticketDetailsRecieved;
    return (
      parseFloat(fieldReceivedTareLoadWeight) >
      parseFloat(fieldReceivedGrossLoadWeight)
    );
  };

  checkShrinkMultiplierValue = () => {
    const { shrinkReconciliation } = this.state.ticketDetailsRecieved;
    return (
      parseFloat(shrinkReconciliation) > 1 ||
      parseFloat(shrinkReconciliation) <= 0
    );
  };

  checklessThanGrossShrunk = value => {
    const { receivedGrossBushels } = this.state.ticketDetailsRecieved;
    return parseFloat(value) > parseFloat(receivedGrossBushels);
  };

  checkNetShrunkPayloadBushels = () => {
    const { receivedNetBushels } = this.state.ticketDetailsRecieved;
    return receivedNetBushels < 0;
  };

  cancelReconciliation = () => {
    const { ticketNumber } = this.state;
    this.setState({ showCancelModal: true });
  };

  handleAccept = () => {
    this.setState({ open: false, showCancelModal: false });
    const { ticketNumber } = this.state;
    //call api
    this.props.actions
      .deleteReconciledTicketDetails(ticketNumber)
      .then(data => {
        if (data) {
          this.props.actions.emptyStateOnReconciliation();
        }
      });
  };

  handleCancel = () => {
    this.setState({ open: false, showCancelModal: false });
  };

  render() {
    const {
      ticketDetailsRecieved,
      buttonLabel,
      formErrors,
      showMessage,
      isButtonDisabled,
      commodityVarietyListOption,
      edited,
      isMandatory,
      reDirect,
      showModal,
      showCancelModal,
      ticketNumber
    } = this.state;
    const {
      isValid,
      commodityList,
      commodityVarietyList,
      reconciled,
      classes
    } = this.props;
    // if(reDirect){
    //   return <Redirect to="/app" />;
    // }
    return (
      <div>
        <Prompt when={edited} message="Changes you made may not be saved." />

        <h3 className="mainHeading" style={{ paddingBottom: "1rem" }}>
          Received Details
        </h3>
        <Grid container spacing={8} style={{ paddingRight: "4em" }}>
          <Grid item xs={6} className="labelFor">
            <div>Reconciled Date</div>
          </Grid>
          <Grid item xs={6}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                className="date-picker"
                autoOk
                disabled
                format="MMM dd, yyyy p"
                value={ticketDetailsRecieved.receivedDate}
                onChange={this.handleDateChange}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Commodity *</div>
          </Grid>
          <Grid item xs={6}>
            <Dropdown
              value={ticketDetailsRecieved.receivedcommodity}
              options={commodityList}
              type="text"
              name="receivedcommodity"
              required
              validations={["required"]}
              fieldError={formErrors.receivedcommodity}
              handleChange={this.handleCommodityChange}
              handleError={this.handleError}
            />
            {showMessage && (
              <span className="showMessage" role="alert">
                Commodity is changed
              </span>
            )}
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Commodity Variety *</div>
          </Grid>
          <Grid item xs={6}>
            <Dropdown
              value={ticketDetailsRecieved.receivedcommodityVariety}
              // options={this.getfilterCommodityList()}
              // options={commodityVarietyList}
              options={commodityVarietyListOption}
              type="text"
              name="receivedcommodityVariety"
              required
              validations={["required"]}
              fieldError={formErrors.receivedcommodityVariety}
              fullform={ticketDetailsRecieved}
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Payload Ticket no. *</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              value={ticketDetailsRecieved.payloadTicketNumber}
              type="text"
              name="payloadTicketNumber"
              required
              validations={["required"]}
              fieldError={formErrors.payloadTicketNumber}
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>
              Gross Weight (lbs){" "}
              {this.toggleMandatoryFields(
                ticketDetailsRecieved.fieldReceivedGrossLoadWeight
              )
                ? "*"
                : ""}
            </div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.fieldReceivedGrossLoadWeight}
              name="fieldReceivedGrossLoadWeight"
              validations={
                this.toggleMandatoryFields()
                  ? ["required", "onlyNumber"]
                  : ["onlyNumber"]
              }
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>
              Tare Weight (lbs)
              {this.toggleMandatoryFields(
                ticketDetailsRecieved.fieldReceivedGrossLoadWeight
              )
                ? "*"
                : ""}
            </div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              //required={this.toggleMandatoryFields ? true:false}
              value={ticketDetailsRecieved.fieldReceivedTareLoadWeight}
              name="fieldReceivedTareLoadWeight"
              fieldError={formErrors.fieldReceivedTareLoadWeight}
              validations={
                this.toggleMandatoryFields()
                  ? ["required", "onlyNumber"]
                  : ["onlyNumber"]
              }
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
            {this.checkTareWeight() && (
              <FormHelperText style={{ color: "red" }}>
                Tare Weight weight cannot be greater than Gross Weight.
              </FormHelperText>
            )}
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Net Weight (lbs)</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.fieldReceivedNetLoadWeight}
              name="fieldReceivedNetLoadWeight"
              disabled
              validations={["onlyNumber"]}
              handleChange={() => {}}
              handleError={this.handleError}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Moisture %</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.fieldsReceivedMoisture}
              name="fieldsReceivedMoisture"
              validations={["onlyNumber", "percentageCheck"]}
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
          </Grid>
          <Grid item xs={6} className="labelFor">
            <div>Reconcilation Shrink Multiplier</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.shrinkReconciliation}
              name="shrinkReconciliation"
              validations={["onlyNumber"]}
              fieldError={formErrors.shrinkReconciliation}
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
            {this.checkShrinkMultiplierValue() && (
              <FormHelperText style={{ color: "red" }}>
                Shrink Multiplier should be between 0 and 1.
              </FormHelperText>
            )}
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Gross Shrunk Payload Bushels</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.receivedGrossBushels}
              name="receivedGrossBushels"
              disabled
              validations={["onlyNumber"]}
              handleChange={() => {}}
              handleError={this.handleError}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Foreign Matter</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.foreignMatter}
              name="foreignMatter"
              validations={["onlyNumber"]}
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
            {this.checklessThanGrossShrunk(
              ticketDetailsRecieved.foreignMatter
            ) && (
              <FormHelperText style={{ color: "red" }}>
                Foreign Matter should be less than Gross Shrunk Payload Bushels.
              </FormHelperText>
            )}
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Deduction bushels</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.receivedDeductionBushels}
              name="receivedDeductionBushels"
              validations={["onlyNumber"]}
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
            {this.checklessThanGrossShrunk(
              ticketDetailsRecieved.receivedDeductionBushels
            ) && (
              <FormHelperText style={{ color: "red" }}>
                Foreign Matter should be less than Gross Shrunk Payload Bushels.
              </FormHelperText>
            )}
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Net Shrunk Payload Bushels </div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.receivedNetBushels}
              name="receivedNetBushels"
              // required
              validations={["onlyNumber"]}
              disabled
              fieldError={formErrors.receivedNetBushels}
              handleError={this.handleError}
              handleChange={this.handleChange}
            />
            {this.checkNetShrunkPayloadBushels() && (
              <FormHelperText style={{ color: "red" }}>
                Net Shrunk Payload Bushels cannot be less than 0.
              </FormHelperText>
            )}
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>
              Payload Net Destination Shrunk Bushels{" "}
              {this.toggleMandatoryFields() ? "" : "*"}
            </div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={
                ticketDetailsRecieved.recievedPayloadNetDestinationShrunkBushels
              }
              name="recievedPayloadNetDestinationShrunkBushels"
              validations={
                this.toggleMandatoryFields()
                  ? ["onlyNumber"]
                  : ["required", "onlyNumber"]
              }
              fieldError={formErrors.recievedPayloadNetDestinationShrunkBushels}
              // disabled={this.toggleMandatoryFields()}
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Test Weight</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.recievedTestWeight}
              name="recievedTestWeight"
              validations={["onlyNumber"]}
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
          </Grid>

          {/* <Grid item xs={6} className="labelFor">
            <div>Accepted weight (lbs)</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.fieldAcceptedLoadWeight}
              name="fieldAcceptedLoadWeight"
              validations={["onlyNumber"]}
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
          </Grid>

          <Grid item xs={6} className="labelFor">
            <div>Rejected Weight (lbs)</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.fieldRejectedLoadWeight}
              name="fieldRejectedLoadWeight"
              validations={["onlyNumber"]}
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
          </Grid> */}

          <Grid item xs={6} className="labelFor">
            <div>Bill of Lading</div>
          </Grid>
          <Grid item xs={6}>
            <InputFiled
              type="text"
              value={ticketDetailsRecieved.billOfLading}
              name="billOfLading"
              handleChange={this.handleChange}
              handleError={this.handleError}
            />
          </Grid>

          {reconciled === "Reconciled" ? (
            <Grid item xs={6} className="labelFor">
              <button
                className="cancelReconcile"
                style={{
                  color: "red",
                  fontSize: "15px",
                  background: "none",
                  border: "none",
                  outline: "none"
                }}
                onClick={this.cancelReconciliation}
              >
                Cancel Reconciliation
              </button>
            </Grid>
          ) : (
            ""
          )}

          <Grid item xs={reconciled === "Reconciled" ? 6 : 12}>
            <div className="buttonContainer">
              <Button
                style={{ display: "flex", alignSelf: "right" }}
                name={reconciled === "Reconciled" ? "Update" : "Reconcile"}
                onclick={this.handleReconcile}
                disabled={
                  isValid ||
                  this.checkTareWeight() ||
                  this.checkTicket() ||
                  this.checkShrinkMultiplierValue() ||
                  this.checklessThanGrossShrunk() ||
                  this.checkNetShrunkPayloadBushels() ||
                  this.checkAllMandatoryFieldsAreFilled() ||
                  isButtonDisabled
                }
              />
            </div>
          </Grid>
        </Grid>

        {showModal && (
          <div>
            <Dialog
              className="overlay"
              open={this.state.open}
              onClose={this.handleClose}
            >
              <p
                style={{
                  color: "green",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              ></p>
              <DialogContent
                style={{
                  padding: "1rem 5rem 1rem 5rem",
                  textAlign: "center"
                }}
              >
                Ticket Reconciled Successfully
              </DialogContent>
              <DialogActions
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "35px"
                }}
              >
                <Button
                  label="Done"
                  onclick={this.handleClose}
                  color="primary"
                  name="OK"
                />
              </DialogActions>
            </Dialog>
          </div>
        )}

        <ConfirmationDialog
          className="overlay"
          open={showCancelModal}
          handleClose={this.handleCancel}
          handleOk={this.handleAccept}
          message="This will remove the reconciled data. Do you want to continue?"
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    postTicketDetails: state.reconciliationReducer.postTicketDetails,
    commodityList: state.contractReducer.commodityList,
    commodityVarietyList: state.contractReducer.commodityVarietyList,
    upDateTicketDetails: state.contractReducer.upDateTicketDetails,
    getTicketDetails: state.reconciliationReducer.TicketDetails,
    reconciledData: state.reconciliationReducer.ReconciledData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        postTicketDetails,
        commodityList,
        getCommodityVariertyList,
        upDateTicketDetails,
        getTicketDetails,
        getReconciledTicketDetails,
        emptyStateOnReconciliation,
        deleteReconciledTicketDetails
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecievedDetails);



// WEBPACK FOOTER //
// ./src/components/private/Reconciliation/RecievedDetails.js